import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
// import '../../../assets/scss/custom/components/_tab.scss';
import useNavigationPage from '../../../../hooks/useNavigationPage';
import { AppContext } from '../../../../contexts/AppContext';
import { AuthContext } from '../../../../contexts/AuthContext';
import useEventService from '../../../../app/services/intranet_company/hooks/useEventService';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import { defaultEvent, Event } from '../../../../app/models/Event';
import { EventParticipationFilters } from '../../../../app/models/EventParticipation';
import Breadcrumbs, {
    BreadcrumbsItem
} from '../../../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../../../components/default/DefaultCard';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';
import useCommuneService from "../../../../app/services/hooks/useCommuneService";
import useRegionService from "../../../../app/services/hooks/useRegionService";
import useCountryService from "../../../../app/services/hooks/useCountryService";
import {Commune} from "../../../../app/models/Commune";
import {Region} from "../../../../app/models/Region";
import {Country} from "../../../../app/models/Country";
import EventFormEdit from "../components/Event/forms/EventFormEdit";
import EventProgramContainer from "../components/EventProgram/EventProgramContainer";
import EventGuestContainer from "../components/EventGuest/EventGuestContainer";

type RouterParams = {
    id: string;
};

const EventEdit = () => {
    const { navigationPage } = useNavigationPage();

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const { id } = useParams<RouterParams>();

    const [verifyingEvent, setVerifyingEvent] = useState<boolean>(true);

    const { editEvent, fetchingEditEvent, updateEvent } = useEventService();
  

    const { authCompany } = useContext(AuthContext);

    const [eventForm, setEventForm] = useState<Event>(defaultEvent);
    const [eventGuests, setEventGuests] = useState<any[]>([]);
    const [eventPrograms, setEventPrograms] = useState<any[]>([]);
    
    
    const { getCommunesByRegion, fetchingGetCommunesByRegion } = useCommuneService();
    const { getRegionsByCountry, fetchingGetRegionsByCountry } = useRegionService();
    const { getCountries, fetchingGetCountries } = useCountryService();
    const regionIdSelected = useRef<number | undefined>(undefined);
    const countryIdSelected = useRef<number | undefined>(undefined);
    const [communes, setCommunes] = useState<Commune[]>([]);
    const [regions, setRegions] = useState<Region[]>([]);
    const [countries, setCountries] = useState<Country[]>([]);

    const [filterEventParticipation, setFilterEventParticipation] =
        useState<EventParticipationFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'asc'
        });


    useEffect(() => {
        edit(parseInt(id));
    }, [id]);

    const [errorFields, setErrorFields] = useState<any>();

    
        useEffect(() => {
        getCountries({
            onSuccess: (response: ServiceResponse) => {
                setCountries(response.data.countries);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    }, []);

    useEffect(() => {
        if (eventForm.region_id && eventForm.region_id != regionIdSelected.current) {
            getCommunesByRegion(eventForm.region_id, {
                onSuccess: (response: ServiceResponse) => {
                    regionIdSelected.current = eventForm.region_id ?? 0;

                    setCommunes(response.data.communes);
                    setEventForm(eventForm);

                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                    eventForm.region_id = Number(regionIdSelected.current);
                    setEventForm(eventForm);
                }
            });
        }
    }, [eventForm.region_id]);

    useEffect(() => {
        if (eventForm.country_id && eventForm.country_id != countryIdSelected.current) {
            getRegionsByCountry(eventForm.country_id, {
                onSuccess: (response: ServiceResponse) => {
                    countryIdSelected.current = eventForm.country_id ?? 0;

                    setRegions(response.data.regions);
                    // eventForm.region_id = 0;
                    setEventForm(eventForm);

                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                    eventForm.country_id = Number(countryIdSelected.current);
                    setEventForm(eventForm);
                }
            });
        }
    }, [eventForm.country_id]);
    
    const edit = (id: number) => {
        editEvent(id, {
            onSuccess: (response: ServiceResponse) => {
                setEventForm(response.data.event);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2500
                });
                if (response.data.to_dashboard) {
                    navigationPage('/events');
                }
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando Evento...');

        updateEvent(Number(eventForm.id), eventForm, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message);
                setErrorFields(undefined);
                setEventForm({ ...eventForm, ...response.data.event });
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Evento',
            url: '/events',
            isActive: false
        },
        {
            name: 'Editar Evento #' + id,
            url: '/events/' + id + '/edit',
            isActive: true
        }
    ];

    return (
        <>
            <Breadcrumbs pageSection={`Información General Evento #${id}`} breadcrumbs={breadcrumbs} />


                    <div className="row">
                        <div className="col-md-12">
                            <DefaultCard>
                                <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                                <EventFormEdit
                                    eventDataForm={eventForm}
                                    countries={countries}
                                    regions={regions}
                                    communes={communes}
                                    setEventDataForm={setEventForm}
                                    errorFields={errorFields}
                                 setCommunes={setCommunes} setRegions={setRegions}/>
                                <div className="row justify-content-end">
                                    <div className="col-auto">
                                        <ButtonSaveForm callbackSave={update!} />
                                    </div>
                                </div>
                            </DefaultCard>
                        </div>
                    </div>
        </>
    );
};

export default EventEdit;
